import React, { FC } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { ReactComponent as CountriesGroupIcon } from "../../../../assets/svg/branch-location.svg";
import { ReactComponent as Location } from "../../../../assets/svg/location.svg";
import { IconWithText } from "../../../program/components/IconWithText";

const useStyles = makeStyles(() => ({
  content: {
    border: "1px solid #C5C5C5",
    background: "#FFFFFF",
    borderRadius: 15,
    marginTop: 16,
    padding: "16px 32px",
    display: "flex",
    flexWrap: "wrap",
    gap: "16px 16px",
  },
  country: {
    border: "1px solid #957F2F",
    borderRadius: 12,
    padding: "5px 11px",
    fontSize: 16,
    fontWeight: 500,
    color: "#858997",
    whiteSpace: "pre",
    display: "flex",
    alignItems: "center",
  },
  icon: {
    marginRight: 4,
  },
}));

interface OperatingCountriesProps {
  countries: string[];
}

export const OperatingCountriesWidget: FC<OperatingCountriesProps> = ({
  countries,
}) => {
  const classes = useStyles();

  return (
    <div>
      <IconWithText Icon={CountriesGroupIcon} title="Operating Countries" />
      <div className={classes.content}>
        {countries.map((doc) => (
          <div key={doc} className={classes.country}>
            <Location className={classes.icon} />
            {doc}
          </div>
        ))}
      </div>
    </div>
  );
};
